import { render, staticRenderFns } from "./chatHeader.vue?vue&type=template&id=49c9ed36&scoped=true"
import script from "./chatHeader.vue?vue&type=script&lang=js"
export * from "./chatHeader.vue?vue&type=script&lang=js"
import style0 from "./chatHeader.vue?vue&type=style&index=0&id=49c9ed36&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49c9ed36",
  null
  
)

export default component.exports